import { useState, useEffect } from 'react';
import AuthModal from '../components/AuthModal';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/common.css';
import axios from 'axios';
import SweetAlert from '../components/SweetAlert';
import { connectAgencySocket, disconnectAgencySocket } from '../utils/socket';
import eyeIcon from '../assets/images/eye.png';
import eyeCloseIcon from '../assets/images/eyeClose.png';

const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('signin');
  const [rememberMe, setRememberMe] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const navigate = useNavigate();
  const openModal = (mode) => {
    setModalMode(mode);
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      setFormData((prev) => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      loginAgency();
    }
  };

  const loginAgency = () => {
    //validate email and password
    if (!formData.email) {
      setErrors({ ...errors, email: 'Email is required' });
    }
    if (!formData.password) {
      setErrors({ ...errors, password: 'Password is required' });
    }
    if (formData.email && formData.password) {
      setErrors({ email: '', password: '' });
      //login agency
      axios.post(`${process.env.REACT_APP_API_URL}/api/website/login-agency`, { email: formData.email, password: formData.password })
        .then(response => {
          if (response.data.status === 1) {
            if (rememberMe) {
              localStorage.setItem('rememberedEmail', formData.email);
            } else {
              localStorage.removeItem('rememberedEmail');
            }
            const { token, refreshToken, agencyData } = response.data;
            connectAgencySocket(agencyData._id);
            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('agencyData', JSON.stringify(agencyData));
            localStorage.setItem('partnerName', agencyData.companyName || '');
            localStorage.setItem('partnerEmail', agencyData.email || '');
            SweetAlert.success('Login Successful!', 'You are now logged in.');
            navigate('/dashboard');
          }
          else if (response.data.status === 0) {
            SweetAlert.error('Login Failed!', response.data.message);
          }
        })
        .catch(error => {

          SweetAlert.error('Login Failed!', error.response.data.message);
        });
    } else {
      setErrors({ ...errors, email: 'Email is required', password: 'Password is required' });
    }
  };

  return (
    <div className="home-container">
      {/* Left Blue Panel */}
      <div className="left-panel">
        <div className="logo-container">
          <img
            src={require('../assets/images/logo.png')}
            alt="24x7 Taxi Logo"
            className="logo"
            style={{ width: '100px', height: '100px', borderRadius: '50%' }}
          />
          {/* <h1>24×7 Taxi</h1> */}
        </div>

        <h2 className="main-heading">
          Manage all your<br />guest transport<br />in one place.
        </h2>

        <p style={{ fontSize: '20px', opacity: '0.95', marginBottom: '50px' }}>
          Book taxis, track drivers in real time, communicate directly, and earn transparent commissions — designed exclusively for hotels and travel agencies.
        </p>

        <div className="stats-container">
          <div className="stat-card">
            <h3 style={{ fontSize: '32px', margin: '0' }}>340+</h3>
            <p>Partner Hotels</p>
          </div>
          <div className="stat-card">
            <h3 style={{ fontSize: '32px', margin: '0' }}>12K+</h3>
            <p>Monthly Trips</p>
          </div>
          <div className="stat-card">
            <h3 style={{ fontSize: '32px', margin: '0' }}>99.2%</h3>
            <p>On-Time Rate</p>
          </div>
        </div>

        <p style={{ marginTop: 'auto', opacity: '0.8', fontSize: '14px' }}>
          © 2026 24×7 Taxi. All rights reserved.
        </p>
      </div>

      {/* Right White Panel */}
      <div className="right-panel">
        <div className="form-container">
          <h2 style={{ fontSize: '32px', marginBottom: '8px' }}>Welcome back</h2>
          <p style={{ color: '#666', marginBottom: '40px' }}>Sign in to your partner account</p>

          <input type="email" placeholder="Email Address *" className="input-field" value={formData.email} onChange={handleChange} name="email" />
          {errors.email && <small className="text-danger">{errors.email}</small>}
          <div className="password-container">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password *"
              className="input-field"
              value={formData.password}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              name="password"
            />
            <img
              src={showPassword ? eyeCloseIcon : eyeIcon}
              alt={showPassword ? 'Hide password' : 'Show password'}
              className="password-toggle"
              onClick={() => setShowPassword(prev => !prev)}
            />
            {errors.password && <small className="text-danger">{errors.password}</small>}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>

            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />{' '}
              Remember me
            </label>

            {/* <button onClick={() => openModal('forgot')} style={{ color: '#0066ff', background: 'none', border: 'none' }}>
              Forgot password?
            </button> */}
            <button onClick={() => navigate('/forgot-password')} style={{ color: '#0066ff', background: 'none', border: 'none', cursor: 'pointer' }}>
              Forgot password?
            </button>
          </div>

          {/* <button onClick={() => openModal('signin')} className="signin-btn">
            Sign In →
          </button> */}
          <button onClick={() => loginAgency()} className="signin-btn">Sign In →</button>

          <p style={{ textAlign: 'center', marginBottom: '30px' }}>
            Don't have an account?{' '}
            {/* <button onClick={() => openModal('signup')} style={{ color: '#0066ff', fontWeight: '600', background: 'none', border: 'none' }}>
              Register your agency
            </button> */}
            <button onClick={() => navigate('/register')} style={{ color: '#0066ff', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer' }}>
              Register your agency
            </button>
          </p>

          <div style={{ background: '#f0f8ff', padding: '15px', borderRadius: '8px', fontSize: '14px', textAlign: 'center' }}>
            All partner accounts are verified and secured.
          </div>
        </div>
      </div>

      <AuthModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        initialMode={modalMode}
      />
    </div>
  );
};

export default Home;